/**
 * File: useSectionMenuPageController.ts
 * Path: apps/admin/src/features/menu/hooks/useSectionMenuPageController.ts
 * Description: Finds the section (CRM, Accounting, CMS) whose own page is open, among the menu items this role may see.
 */

import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";
import { useMenuItems } from "@/modules/layout/hooks/useMenuItemsQueries";

export const useSectionMenuPageController = () => {
  const { pathname } = useLocation();
  const { can } = useRole();
  const items = useMenuItems();
  const group = useMemo(() => items.find((item) => item.hub === pathname), [items, pathname]);
  return { group, canSeeLeads: can("sales") };
};
